import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { FETCH_STOCK_CATEGORY_LATEST_STOCKS } from "./graphql";

const ShopifyInventoryView = ({ shipment }) => {
  const { loading, error, data } = useQuery(
    FETCH_STOCK_CATEGORY_LATEST_STOCKS,
    {
      variables: { stockCategoryId: shipment.toLocationId },
      fetchPolicy: "network-only",
    },
  );

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const stockCategoryLatestStocks = JSON.parse(
    data.stockCategoryLatestStocks || "{}",
  );
  const shopifyStocks = JSON.parse(data.shopifyStocks || "[]");

  const productStocks = Object.values(stockCategoryLatestStocks).reduce(
    (stocks, { product_id, latest_qty }) => ({
      ...stocks,
      [product_id]: latest_qty,
    }),
    {},
  );

  const products = shipment.lines.map((line) => {
    const productStock = productStocks[line.product.id];
    const shopifyStock = shopifyStocks.find(
      (s) => s.item.sku === line.product.number,
    );

    const shopifyStockOnHand = shopifyStock
      ? shopifyStock.quantities.find((i) => i.name === "on_hand")
      : null;
    const shopifyStockAvailable = shopifyStock
      ? shopifyStock.quantities.find((i) => i.name === "available")
      : null;

    return {
      ...line.product,
      stock: productStock || 0,
      shopifyStockOnHand: shopifyStockOnHand ? shopifyStockOnHand.quantity : 0,
      shopifyStockAvailable: shopifyStockAvailable
        ? shopifyStockAvailable.quantity
        : 0,
      delta: line.qty,
    };
  });

  return (
    <div className="text-sm">
      <div className="-mx-2">
        <table>
          <thead>
            <tr>
              <th>Product</th>
              <th className="text-right">WIS Stock</th>
              <th className="text-right">Shopify Available</th>
              <th className="text-right">Shopify On Hand</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => (
              <tr key={product.id} className="border-y">
                <td>
                  [{product.number}] {product.name}
                </td>
                <td className="text-right">{product.stock}</td>
                <td className="text-right">{product.shopifyStockAvailable}</td>
                <td className="text-right">{product.shopifyStockOnHand}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShopifyInventoryView;
